/**
 * @author: Wangwei
 * @description: 打卡学习
 */
import { useRequest } from 'umi';
import React, { useState, useEffect } from 'react';
import styles from '../css/cmapDetailsCSS.less';
import CampStudy from './detail/CampStudy';
import StudyRight from './detail/StudyRight';
import CampReward from './detail/CampReward';
import CampSuccessText from './detail/CampSuccessText';
import { StudyInfoType } from '@/types/camp/study/studentBaseInfoType';
import { getDynamicPage } from '@/utils/requests/camp/requests_dynamic';
import { DynamicType } from '@/types/camp/dynamic/dynamicType';
import MoreLink from '@/components/moreLink';
import DynamicItem from '@/pages/camp/components/dynamic/dynamicItem';
import CampRanking from './detail/CampRanking';
import { CampStudyState } from '@/types/camp/study';
import { ProgressType } from '@/types/camp/details/detailsType';
import { getNodeProgress } from '@/utils/requests/camp/requests_study';

interface Props {
  studentBaseInfo: StudyInfoType | null;
  setTabKey: (tabkey: string) => void;
}

const StudyMain: React.FC<Props> = ({ studentBaseInfo, setTabKey }) => {
  const [pageData, setPageData] = React.useState<DynamicType[]>([]);
  const [nodeProgress, setNodeProgress] = useState<ProgressType>();
  const [total, setTotal] = React.useState<number>(0);
  const [hash, setHash] = React.useState<number>();

  // 获取动态分页
  const { run: getDynamicPageRequest } = useRequest(
    (studentBaseInfo) => {
      const params = {
        campId: studentBaseInfo?.camp.id || '',
        batchId: studentBaseInfo?.batchId || '',
        selected: 1,
        current: 1,
        size: 3,
      };
      return getDynamicPage(params);
    },
    {
      manual: true,
      onSuccess: (res) => {
        setPageData(res.records);
        setTotal(res.total);
      },
    },
  );

  // 获取进度
  const { run: getNodeProgressRequest } = useRequest(
    (signUpId) => {
      return getNodeProgress(signUpId);
    },
    {
      manual: true,
      onSuccess: (res) => {
        setNodeProgress(res);
      },
    },
  );

  useEffect(() => {
    studentBaseInfo?.camp.id && getDynamicPageRequest(studentBaseInfo);
    studentBaseInfo?.id && getNodeProgressRequest(studentBaseInfo?.id);
  }, [studentBaseInfo?.camp.id]);

  return (
    <div className={styles.details_layout_box}>
      <div className={styles.lf} style={{ paddingBottom: 24 }}>
        <div>
          <CampSuccessText studentBaseInfo={studentBaseInfo} />
        </div>
        <div>
          <CampStudy studentBaseInfo={studentBaseInfo} nodeProgress={nodeProgress} />
        </div>
        <div>
          <CampReward studentBaseInfo={studentBaseInfo} />
        </div>
        {studentBaseInfo?.campStudyState !== CampStudyState.NOT_START_LEARNING && (
          <div>
            <CampRanking studentBaseInfo={studentBaseInfo} />
          </div>
        )}

        {total > 0 && (
          <div className="com_cmap_card_box" style={{ marginTop: 24, marginBottom: 24 }}>
            <div className="f20 fw600" style={{ marginBottom: 16 }}>
              精选动态
            </div>
            {pageData.map((item, index) => (
              <DynamicItem key={index} item={item} index={index} setHash={setHash} />
            ))}
            <div style={{ textAlign: 'center', paddingTop: 14 }}>
              <div style={{ width: 150, margin: '0 auto' }}>
                {total > 3 ? (
                  <span onClick={() => setTabKey('2')} className={styles.info}>
                    <MoreLink
                      url="javascript:;"
                      text="查看更多"
                      css="f14 col008 hover008"
                      iconCss="f14"
                    />
                  </span>
                ) : (
                  <span className="col808">—— 没有更多了 ——</span>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      <div className={styles.rt}>
        <StudyRight studentBaseInfo={studentBaseInfo} nodeProgress={nodeProgress} />
      </div>
    </div>
  );
};
export default StudyMain;
